module.exports = __webpack_public_path__ + "img/container-grey.151fdf7b.svg";